var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlowLinear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flow-linear",
    transform: "translate(0.000000, 4.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.15913053,5.00150979 L0.97764849,5.00150979 C0.439941819,5.00150979 0,4.53213625 0,3.9943209 C0,3.45650556 0.439941819,3.0041154 0.97764849,3.0041154 L4.15713951,3.0041154 C4.56899808,1.83677379 5.68452858,1 6.99606268,1 C8.30759677,1 9.42312728,1.83677379 9.83498584,3.0041154 L12.8146846,3.0041154 C11.91704,2.24827723 11.4110474,1.81148845 11.2967067,1.69374907 C11.1251958,1.51713999 11.0038962,1.26240997 11.0038962,0.988613065 C11.0038962,0.450797719 11.4580946,0 11.9958013,0 C12.2695428,0 12.5173345,0.108119169 12.6933112,0.293909925 C12.810629,0.417770429 13.8150938,1.42307667 15.7067054,3.30982864 C15.8826822,3.48584094 16,3.720524 16,3.9943209 C16,4.2681178 15.8924586,4.51257933 15.7164819,4.68859162 L12.6980554,7.71642464 C12.5220787,7.89243693 12.2776666,8 12.003925,8 C11.4508511,8 11.0038962,7.55263506 11.0038962,7.01481972 C11.0038962,6.74102281 11.12073,6.47013512 11.2967067,6.29412282 L12.8146846,5.00150979 L9.83299482,5.00150979 C9.41954146,6.16591343 8.30548914,7 6.99606268,7 C5.68663622,7 4.5725839,6.16591343 4.15913053,5.00150979 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowLinear);
export default __webpack_public_path__ + "static/media/flow-linear.001032eb3aa31e0c1d9e18053af0026a.svg";
export { ForwardRef as ReactComponent };